var styles = {"quantityForPrice":"ep-pricing-module-quantity-for-price-cXVhb"};

export { styles as default };
